import { render, staticRenderFns } from "./DbOverview.vue?vue&type=template&id=5e178698&scoped=true&"
import script from "./DbOverview.vue?vue&type=script&lang=js&"
export * from "./DbOverview.vue?vue&type=script&lang=js&"
import style0 from "./DbOverview.vue?vue&type=style&index=0&id=5e178698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e178698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
